<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <campaign-template-item-picker-table
                :url="url"
                @select="onSelect"
        ></campaign-template-item-picker-table>
    </el-dialog>
</template>

<script>
  import eventBus from '../../event-bus';
  import CampaignTemplateItemPickerTable from '../../components/campaign-template/item-picker-table';

  export default {
    components: {
      CampaignTemplateItemPickerTable
    },

    props: {
      url: String,
    },

    data() {
      return {
        isVisible: false,
      };
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        return 'Template Selection'
      },
    },
    methods: {
      /**
       * @return {undefined}
       */
      show() {
        this.isVisible = true;
      },

      /**
       * @return {undefined}
       */
      hide() {
        this.isVisible = false;
      },

      /**
       * @param {object} row
       * @emits select
       */
      onSelect(row) {
        this.hide();
        this.$emit('select', row);
      }
    },

    created() {
      eventBus.$on('show-campaign-templates-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-campaign-templates-dialog', this.show);
    }
  }
</script>
